module.exports = __webpack_public_path__ + "static/media/md-car.c9f0a754.svg";